import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Schedule} from "../../../types/interfaces";

@Component({
    selector: 'app-calendar',
    templateUrl: './calendar.component.html',
    styleUrls: ['./calendar.component.scss'],
})
export class CalendarComponent implements OnInit {

    @Input() holidays: Array<any> = [];
    @Input() schedule: Schedule[] = [];
    @Input() minDate: any = null;
    @Input() maxDate: any = null;

    @Output() onDateSelected = new EventEmitter();

    constructor() {

        this.date = new Date();

        this.month = this.date.getMonth();
        this.year = this.date.getFullYear();

    }

    ngOnInit() {
        this.buildCalendarData();
    }

    public date: Date;

    public month: number;
    public year: number;

    public daysInMonths = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    public monthLength: number;

    // these are labels for the days of the week
    // public dayShortNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    public dayShortNames = [
        'calendar.short.sunday',
        'calendar.short.monday',
        'calendar.short.tuesday',
        'calendar.short.wednesday',
        'calendar.short.thursday',
        'calendar.short.friday',
        'calendar.short.saturday'];

    public dayIndex = [1, 2, 3, 4, 5, 6, 0];

    public dayRows = [];

    // these are human-readable month name labels, in order
    // public monthsNames = ['January', 'February', 'March', 'April',
    //     'May', 'June', 'July', 'August', 'September',
    //     'October', 'November', 'December'];

    public monthsNames = [
        'calendar.month.january',
        "calendar.month.february",
        "calendar.month.march",
        "calendar.month.april",
        "calendar.month.may",
        "calendar.month.june",
        "calendar.month.july",
        "calendar.month.august",
        "calendar.month.september",
        "calendar.month.october",
        "calendar.month.november",
        "calendar.month.december",];

    // ngAfterViewInit() {
    //
    //     // this.date = new Date();
    //     //
    //     // this.month = this.date.getMonth();
    //     // this.year = this.date.getFullYear();
    //
    //     //console.log(this.availableDates);
    //
    //     this.buildCalendarData();
    //
    // }

    // ngOnChanges() {
    //
    //     this.buildCalendarData();
    //
    // }

    selectDate(day: any) {
        // this.onDateSelected.emit(day);

    }

    buildCalendarData() {
        //console.log(this.holidays);

        this.dayRows = [];

        // find number of days in month
        this.monthLength = this.daysInMonths[this.month];

        // compensate for leap year
        if (this.month == 1) { // February only!
            if ((this.year % 4 == 0 && this.year % 100 != 0) || this.year % 400 == 0) {
                this.monthLength = 29;
            }
        }

        var firstDay = new Date(this.year, this.month, 1);
        var startingDay = firstDay.getDay();

        var today = new Date(),
            todayDate = today.getFullYear() + '-' +
                (today.getMonth() < 9 ? '0' + (today.getMonth() + 1) : today.getMonth() + 1) + '-' +
                (today.getDate() < 10 ? '0' + today.getDate() : today.getDate());


        // fill in the days
        var day = 1;
        // this loop is for is weeks (rows)
        var tmp = [],
            hasDay = false;
        for (var i = 0; i < 7; i++) {

            tmp = [];
            hasDay = false;

            for (var j of this.dayIndex) {

                var isDay = i > 0 || j >= startingDay || day > 1;
                if (startingDay == 0) {
                    isDay = i > 0 || j == 0;
                }
                //console.log(this.availableDates);
                if (day <= this.monthLength && isDay) {

                    var _m = this.month + 1;
                    let dayDate = this.year + '-' + (_m > 9 ? _m : '0' + _m) + '-' + (day > 9 ? day : '0' + day);
                    // console.log(dayDate)

                    let is_holiday = this.holidays.some(holidayArray => holidayArray.indexOf(dayDate) >= 0);


                    // let is_holiday = this.holidays.indexOf(dayDate) >= 0;
                    // let is_holiday = false;

                    let color = '';
                    let absence = false;


                    this.schedule.forEach(group => {
                        group.lessons.forEach(lesson => {
                            if (lesson.date === dayDate) {
                                if (lesson.absence) {
                                    absence = true;
                                } else {
                                    color = color + '-' + group.groupColor;
                                }


                            }
                        })

                    });


                    tmp.push({
                        empty: false,
                        day: day,
                        title: this.dayShortNames[j],
                        date: dayDate,
                        holiday: is_holiday,
                        absence: absence,
                        week_day: j,
                        color: color,
                    });
                    day++;
                    hasDay = true;
                } else {
                    tmp.push({
                        empty: true
                    });
                }

            }

            if (hasDay) {
                // @ts-ignore
                this.dayRows.push(tmp);
            }

        }

    }

    prevMonth() {

        var m = this.month,
            y = this.year;

        if (m == 0) {
            m = 11;
            y--;
        } else {
            m--;
        }

        this.month = m;
        this.year = y;

        this.buildCalendarData();

    }

    nextMonth() {

        var m = this.month,
            y = this.year;

        if (m == 11) {
            m = 0;
            y++;
        } else {
            m++;
        }

        this.month = m;
        this.year = y;

        this.buildCalendarData();

    }

}
